// extracted by mini-css-extract-plugin
export default {"header_container":"SingleAudiencePage_header_container__v5Fj6","buttons_container":"SingleAudiencePage_buttons_container__y3GUM"};